import { render } from "./VimeoPlayer.vue?vue&type=template&id=f5f5788a&scoped=true"
import script from "./VimeoPlayer.vue?vue&type=script&lang=js"
export * from "./VimeoPlayer.vue?vue&type=script&lang=js"

import "./VimeoPlayer.vue?vue&type=style&index=0&id=f5f5788a&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-f5f5788a"

export default script